//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"CheckNewerRevisionsOfTemplatePart",1,0],[0,"ComponentMemberSelect",1,0],[0,"CreatePersistentConstraints",1,0],[0,"DisplayUpdateReport",1,0],[0,"DragHandlePositionPreference",1,0],[0,"InterpartPositioning",1,0],[0,"PartNameAttribute",1,0],[0,"PartNameStyle",1,0],[0,"PositioningArrangementTargetPreference",1,0],[0,"PositioningTaskCollectionForDesignElements",1,1],[0,"PreviewComponentOnAdd",1,1],[0,"ProductInterfaceEmphasize",1,1],[0,"SimplifyPrepopulate",1,0],[0,"TemplateOptionForNewAssembly",1,0],[0,"TemplateOptionForNewComponent",1,0],[0,"TemplateOptionForNewParent",1,0],[0,"TolerantPositioning",1,0],[0,"TrueShapeFiltering",1,0],[0,"UpdateDesignElementPositionOnLoad",1,1],[0,"UpdateStructureOnExpand",1,0],[0,"WarnOnDelete",1,0],[0,"WarnOnDragDrop",1,0],[0,"WorkPartDisplayAsEntirePart",1,0],[0,"WorkPartEmphasize",1,1],[0,"WorkPartMaintain",1,1],[0,"WorkPartWarnOnAutomaticChange",1,0]],[],[]];
SPLM.Preferences.SessionAssemblies = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.SessionAssemblies";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.SessionAssemblies.PartNameOption = Object.freeze({
    "FileName" : "FileName", "Description" : "Description", "SpecifiedAttributes" : "SpecifiedAttributes"});

SPLM.Preferences.SessionAssemblies.PositioningTaskCollectionOptionForDesignElements = Object.freeze({
    "Work" : "Work", "Context" : "Context"});

SPLM.Preferences.SessionAssemblies.DragHandlePositionOption = Object.freeze({
    "CenterOfBoundingBox" : "CenterOfBoundingBox", "OriginOfComponent" : "OriginOfComponent"});

SPLM.Preferences.SessionAssemblies.TemplateTypeOptionForNewParentTemplate = Object.freeze({
    "Gateway" : "Gateway", "Assemblies" : "Assemblies", "SelectFromFile" : "SelectFromFile"});

SPLM.Preferences.SessionAssemblies.TemplateTypeOptionForNewAssemblyTemplate = Object.freeze({
    "Gateway" : "Gateway", "Assemblies" : "Assemblies", "SelectFromFileNew" : "SelectFromFileNew"});

SPLM.Preferences.SessionAssemblies.TemplateTypeOptionForNewComponentTemplate = Object.freeze({
    "Modeling" : "Modeling", "Gateway" : "Gateway", "Assemblies" : "Assemblies", "SelectFromFileNew" : "SelectFromFileNew"});

SPLM.Preferences.SessionAssemblies.PositioningArrangementTargetOption = Object.freeze({
    "AllArrangements" : "AllArrangements", "ActiveArrangement" : "ActiveArrangement"});

export default SPLM;